import type { MonsterDef } from '../../sim/registry';
import { COLOSSI, registerColossusScripts } from './colossi';
import { DEEPVAULT, registerDeepvaultScripts } from './deepvault';
import { SIEGE, registerSiegeScripts } from './siege';

/**
 * Endgame boss encounters: Colossus Hunts, the Deepvault (Sunken Reliquary)
 * and the Warlord Siege. `ENDGAME_BOSSES` holds every MonsterDef these
 * encounters need — the bosses, their Hard variants and their helper actors
 * (adds, pillars, orbs, clones) — so registering the list registers every
 * skill. `registerEndgameBossScripts()` wires the BossScripts and the
 * host-side encounter watchers.
 *
 * Instance notes: spawn each boss at level 30 at the centre of its arena
 * (`params.arenaRadius` sizes edge mechanics; override per instance with
 * `setEncounterArena`). Siege Hard mode = spawn `siegeBossId(id, true)`.
 */
export const ENDGAME_BOSSES: MonsterDef[] = [...COLOSSI, ...DEEPVAULT, ...SIEGE];

/** Encounter rosters by instance (boss ids only, Normal difficulty). */
export const ENDGAME_ENCOUNTERS = {
  colossus: ['cinderhide', 'gloomfang', 'rimebound', 'dunestrider'],
  deepvault: ['drowned_warden', 'tide_siren'],
  siege: [['hellhound_kharos', 'hellhound_vesh'], ['vhalzeroth'], ['vhalzeroth_phantom']],
} as const;

let registered = false;

/** Registers every endgame BossScript and encounter watcher. Safe to call more than once. */
export function registerEndgameBossScripts(): void {
  if (registered) return;
  registered = true;
  registerColossusScripts();
  registerDeepvaultScripts();
  registerSiegeScripts();
}

export { enc as encounterState, setEncounterArena } from './common';
export { SIEGE_HARD_HP, siegeBossId } from './siege';
